import React, { useState } from 'react';
import axios from 'axios';
import './login.css'; // Import the CSS file

const Login = ({ onLogin }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post('https://api.headsupfortails.com/v1/finance/login', { email, password });
            const userData = response.data;

            // Store user data and login time in localStorage
            const loginTime = new Date().getTime(); // Get current time in milliseconds
            localStorage.setItem('user', JSON.stringify(userData));
            localStorage.setItem('loginTime', loginTime); // Store login time

            onLogin(userData); // Pass user data to parent component (App)
        } catch (error) {
            setError(error.response?.data?.message || 'Login failed');
        }
    };

    return (
        <div className="modal">
            <div className="modal-content">
                <img src="/santa_huft_logo.avif" alt="Huft Logo" className="logo" />
                <h2>Login</h2>
                <form onSubmit={handleLogin}>
                    {/* Email input */}
                    <input
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)} // Update email state
                        className="input-field"
                    />
                    {/* Password input */}
                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)} // Update password state
                        className="input-field"
                    />
                    {/* Submit button */}
                    <button type="submit" className="submit-button">Login</button>
                </form>
                {/* Display error if login fails */}
                {error && <p className="error-message">{error}</p>}
            </div>
        </div>
    );
};

export default Login;
